import { usePlatformUpdate } from '@reapitform/hooks'
import { IDefaultLink, TSchemaAddLink } from '../../types'

export const useDefaultsLinkUpdate = () => {
  const path: string = '/api/Organization/DefaultLink/'

  const [updateLink, isLoading, returnData, isSuccess, isError] = usePlatformUpdate<TSchemaAddLink, IDefaultLink>({
    path: path,
    method: 'PUT',
    headers: {},
    errorMessage: 'Failed to update the link',
    successMessage: 'Link successfully updated',
  })

  return { updateLink, returnData, isLoading, isSuccess, isError }
}
